import { format } from 'date-fns';

/**
 * CalendarHeader - Month/week title, navigation controls, and add button
 */
export default function CalendarHeader({
  currentMonth,
  currentWeek,
  isMobile,
  eventsCount,
  onPrevious,
  onNext,
  onToday,
  onAddEntry,
}) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <h2 className="text-2xl font-display font-medium" style={{ color: 'var(--color-text-primary)' }}>
          {isMobile 
            ? format(currentWeek, 'MMM yyyy')
            : format(currentMonth, 'MMMM yyyy')
          }
        </h2>
        <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
          {eventsCount} events this period
        </p>
      </div>

      <div className="flex items-center gap-3">
        {/* Navigation */}
        <div 
          className="flex items-center gap-1 rounded-sm shadow-sm"
          style={{ 
            backgroundColor: 'var(--color-bg-canvas)',
            border: '1px solid var(--color-border-subtle)',
          }}
        >
          <button
            onClick={onPrevious}
            className="p-2 rounded-l-sm transition-colors"
            style={{ color: 'var(--color-text-secondary)' }}
          >
            <ChevronLeftIcon className="w-5 h-5" />
          </button>
          <button
            onClick={onToday}
            className="px-3 py-2 text-sm font-medium transition-colors"
            style={{ color: 'var(--color-text-secondary)' }}
          >
            Today
          </button>
          <button
            onClick={onNext}
            className="p-2 rounded-r-sm transition-colors"
            style={{ color: 'var(--color-text-secondary)' }}
          >
            <ChevronRightIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Add Event Button */}
        <button onClick={onAddEntry} className="btn-primary">
          <PlusIcon className="w-4 h-4" />
          <span className="hidden sm:inline">Add Entry</span>
        </button>
      </div>
    </div>
  );
}

function ChevronLeftIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
    </svg>
  );
}

function ChevronRightIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  );
}

function PlusIcon({ className }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
    </svg>
  );
}
